import { Popover, Transition } from '@headlessui/react';
import { DownArrowIcon, PlusIcon } from 'assets/icons';
import classNames from 'classnames';
import React, { FC, Fragment, useEffect, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { AmountFilter } from 'components/custom-amount-filter/CustomAmountFilter';
import { AmountFilterOperation } from 'constants/common';
import EstimateMoreFilterPopoverPanel from './EstimateMoreFilterPopoverPanel';

interface EstimateMoreFilterProps {
  data: any[];
  dataKey: string;
  selectedDraftArray: string[];
  setSelectedDraftArray: (selectedDraftArray: string[]) => void;
  setSelectedArray: (selectedArray: string[]) => void;
  searchText?: string;
  setSearchText?: (searchText: string) => void;
  dataIdKey: string;
  filterPlaceholderText: string;
  filterPlaceholderStyle?: string;
  searchPlaceHolderText?: string;
  searchInputStyle?: string;
  allowSearch: boolean;
  showResultsCount?: boolean;
  secondaryDataKey?: string;
  searchFilterId?: string;
  customClassName?: string;
  filterId?: string;
  amountFilter: AmountFilter;
  setAmountFilter: (amountFilter: AmountFilter) => void;
}

const EstimateMoreFilter: FC<EstimateMoreFilterProps> = ({
  data,
  dataKey,
  selectedDraftArray,
  setSelectedDraftArray,
  setSelectedArray,
  dataIdKey,
  filterPlaceholderText,
  filterPlaceholderStyle = '',
  allowSearch,
  showResultsCount = true,
  secondaryDataKey = '',
  customClassName,
  filterId,
  amountFilter,
  setAmountFilter
}) => {
  const { filterOperation, minAmount, maxAmount } = amountFilter ?? {};

  const [operation, setOperation] = useState<AmountFilterOperation>();
  const [startValue, setStartValue] = useState<number>();
  const [endValue, setEndValue] = useState<number>();

  useEffect(() => {
    setOperation(filterOperation);
    setStartValue(minAmount);
    setEndValue(maxAmount);
  }, [filterOperation, minAmount, maxAmount]);

  return (
    <Popover className="relative">
      {({ open, close }) => (
        <>
          <Popover.Button
            className={twMerge(
              `shrink-0 rounded-md border 
                bg-primary px-3 py-2 text-base font-semibold text-primaryText  
                outline-none transition-all  duration-150 ease-linear focus:outline-none 
               border-dashed`,
              classNames({ [customClassName]: customClassName })
            )}
            id={filterId}
            style={{ borderColor: '#ACB5BD' }}
            type="button">
            <div className={'flex shrink-0 flex-row items-center'}>
              <div>
                <PlusIcon />
              </div>
              <div id={`${filterId}-text`} className={'shrink-0 px-3 text-sbase'}>
                More filters
              </div>
              <div>
                <DownArrowIcon className={open ? 'rotate-180' : ''} />
              </div>
            </div>
          </Popover.Button>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1">
            <Popover.Panel className="absolute z-40 mt-0.5 min-w-[200px] bg-primary px-4 shadow-md sm:px-0">
              <EstimateMoreFilterPopoverPanel
                data={data}
                dataKey={dataKey}
                selectedDraftArray={selectedDraftArray}
                setSelectedDraftArray={setSelectedDraftArray}
                setSelectedArray={setSelectedArray}
                dataIdKey={dataIdKey}
                filterPlaceholderText={filterPlaceholderText}
                filterPlaceholderStyle={filterPlaceholderStyle}
                allowSearch={allowSearch}
                showResultsCount={showResultsCount}
                filterId={filterId}
                secondaryDataKey={secondaryDataKey}
                close={close}
                operation={operation}
                setOperation={setOperation}
                startValue={startValue}
                setStartValue={setStartValue}
                endValue={endValue}
                setEndValue={setEndValue}
                amountFilter={amountFilter}
                setAmountFilter={setAmountFilter}
              />
            </Popover.Panel>
          </Transition>
        </>
      )}
    </Popover>
  );
};

export default EstimateMoreFilter;
